import styled, {css} from 'styled-components';
import Icon from '@/atoms/Icon/Icon';
import colors from '@/theme/constants/colors';
import {StyledIconProps} from './typings';

const textStroke = (width, color) => css`
  text-stroke: ${width}px ${color};
  -webkit-text-stroke: ${width}px ${color};
`;

export const StyledIcon = styled(Icon)<StyledIconProps>`
  ${(props) =>
    props.$active
      ? css`
          ${textStroke(0, 'transparent')}
          color: ${colors.red100};
        `
      : css`
          ${textStroke(1, colors.darkBlue100)}
          color: transparent;
        `}
`;
